<template>
    <div class="zntmain">
        <div class="topbox">
            <div class="leftbox">
                <div class="back"><i class="el-icon-arrow-left" @click="gopage"></i></div>
                <div :class="menu == 'ai' ? 'btnitem btned' : 'btnitem'" @click="menuclick('ai')">AI智控</div>
                <div :class="menu == 'sd' ? 'btnitem btned' : 'btnitem'"  @click="menuclick('sd')">手动控制</div>
            </div>
            <!-- <div class="rightbox">更新:{{time.substr(0, 16)}}</div> -->
        </div>
        <div class="content">
            <Zd v-if="menu == 'ai'" />
            <Ctr v-if="menu == 'sd'" />
        </div>
    </div>

</template>

<script>
import Zd from './coms/zd.vue';
import Ctr from './coms/ctr.vue';
import {getsblist} from '@/api/bot'
export default {
    name: 'index',
    components: { Zd, Ctr },
    data() {
        return {
            menu: 'ai',
            time: ''
        }
    },
    computed: {

    },
    mounted() {
        this.getlist()
    },
    methods: {
        getlist() {
            getsblist().then(res => {
                console.log('设备列表', res)
                this.time = res.data[0].updateTime
            })
        },
        menuclick(e) {
            this.menu = e
        },
        gopage() {
            this.$emit('gopage', 0)
        }
    }
}




</script>

<style scoped lang="less">
.zntmain {
    width: 100%;
    height: 100%;
    position: relative;
    background: linear-gradient( 129deg, #C8D598 0%, #DDE5C8 100%);
    padding: 12px;

    .topbox{
        width: 100%;
        display: flex;
        justify-content: space-between;
        .leftbox{
            display: flex;
            align-items: center;
            align-content: center;
            .back{
                padding: 6px 10px;
                background: rgba(255,255,255,0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 8px;
                font-size: 18px;
            }
            .btnitem{
                margin-left: 10px;
                font-size: 14px;
                padding: 8px 15px;
                background: rgba(255,255,255,0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 8px;
            }
            .btned{
                background: linear-gradient( 206deg, #FFAAC0 0%, #D94E6B 100%);
                color: #fff; 
                border: 0;
            }
        }
        .rightbox{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 12px;
            color: #00000080;
        }
    }

   
}
</style>
